import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Box,
} from "@mui/material";

const HolidayList = () => {
  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/holidays.json")
      .then((res) => res.json())
      .then((data) => {
        setHolidays(data);
        setLoading(false);
      });
  }, []);

  return (
    <Container maxWidth="md">
      <Typography
        variant="h4"
        align="center"
        sx={{ mt: 4, mb: 3, fontWeight: "bold", color: "#1976d2" }}
      >
        📅 Company Holidays – 2025
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center" mt={5}>
          <CircularProgress />
        </Box>
      ) : (
        <Paper elevation={3} sx={{ borderRadius: 3 }}>
          <TableContainer sx={{ maxHeight: 500 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", backgroundColor: "#1976d2", color: "#fff" }}>
                    Date
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", backgroundColor: "#1976d2", color: "#fff" }}>
                    Day
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", backgroundColor: "#1976d2", color: "#fff" }}>
                    Holiday
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {holidays.map((holiday, index) => (
                  <TableRow
                    key={index}
                    sx={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff" }}
                  >
                    <TableCell>{holiday.date}</TableCell>
                    <TableCell>{holiday.day}</TableCell>
                    <TableCell>{holiday.name}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}
    </Container>
  );
};

export default HolidayList;
